import { FC } from 'react';
import cn from 'classnames';
import { UiIcon } from '@frontend/znanie-uikit';

import { Link } from 'components/common/Link';
import LayoutConfines from 'components/layout/LayoutConfines';

import { trackAnalyticsData } from 'utils/analytics';

import * as C from './ServicesLinks.const';

import css from './ServicesLinks.module.scss';

export const ServicesLinks: FC = () => {
  return (
    <LayoutConfines>
      <div className={css.container}>
        {C.SERVICES.map((service, index) => (
          <Link
            data-testid={service.testId}
            key={`service_link_${index}`}
            href={service.link}
            onClick={() => trackAnalyticsData(service.analyticEvent)}
          >
            <div className={cn(css.service, service.class)}>
              <div className={cn(css.background, service.class)} />
              <div className={css.info}>
                <div className={css.description}>
                  <div className={css.title}>{service.title}</div>
                  <UiIcon name="arrow-in-circle" className={css.icon} />
                </div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </LayoutConfines>
  );
};
